import { assignInlineVars } from '@vanilla-extract/dynamic';

import { tag, colorVar } from './tag.css';

export const Tag = ({ color, style, ...rest }) => (
  <button
    className={tag}
    style={{ ...assignInlineVars({ [colorVar]: color }), ...style }}
    {...rest}
  />
);
